function debounce(callback, wait) {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => callback.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement?.setAttribute('aria-expanded', 'false');
  summaryElement?.focus();
}

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input) return;

    this.input.form?.addEventListener('reset', this.onFormReset.bind(this));
    this.input.addEventListener('input', debounce(this.onChange.bind(this), 300));
  }

  onChange() {
    this.toggleResetButton();
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    this.resetButton.classList.toggle('hidden', this.input.value.length === 0);
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (!this.shouldResetForm()) return;

    this.input.value = '';
    this.input.focus();
    this.toggleResetButton();
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm);
}
